import { render } from "./KingdomEventNotification3.vue?vue&type=template&id=363cf060"
import script from "./KingdomEventNotification3.vue?vue&type=script&lang=js"
export * from "./KingdomEventNotification3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/KingdomEventNotification3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "363cf060"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('363cf060', __exports__)) {
    api.reload('363cf060', __exports__)
  }
  
  module.hot.accept("./KingdomEventNotification3.vue?vue&type=template&id=363cf060", () => {
    api.rerender('363cf060', render)
  })

}


export default __exports__